// extracted by mini-css-extract-plugin
module.exports = {"left_wrapper":"costcalculator_left_wrapper__hTfDB","cost_of_title":"costcalculator_cost_of_title__Pc7NP"};